const consts = {};

/**
 * Device type.
 */
consts.TYPE = {
    NEONATAL: 1,
    ADULT: 2,
    VENTILATOR: 3,
    HIGH_FLOW: 4,
    CONCENTRATOR: 5,
    VITAL_SIGNS: 6,
};

module.exports = consts;
